import { forwardRef, useImperativeHandle, useState } from "react";
import { useControlWebSocket } from "@/hooks/useControlWebSocket";
import { message } from "antd";

export interface StartRecordErrorDialogRef {
  show: (status: string, errorMessage: string) => void;
  hide: () => void;
}

const StartRecordErrorDialog = forwardRef<
  StartRecordErrorDialogRef
>((_, ref) => {
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const { stopRecording } = useControlWebSocket();

  const show = (errorStatus: string, msg: string) => {
    setStatus(errorStatus);
    setErrorMessage(msg);
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
    setStatus("");
    setErrorMessage("");
  };

  const handleCancel = () => {
    hide();
  };

  const handleStopRecording = async () => {
    try {
      await stopRecording();
      message.success("已发送结束录制指令");
      hide();
    } catch (error) {
      console.error("结束录制失败:", error);
      message.error("结束录制失败，请重试");
    }
  };

  const handleKnow = () => {
    hide();
  };

  useImperativeHandle(ref, () => ({
    show,
    hide,
  }));

  if (!visible) return null;

  // 判断是否是在总结页的情况
  const isInSummaryPage = status === "in_summary_page";

  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center">
      {/* 遮罩层 */}
      <div className="absolute inset-0 bg-black/50" />

      {/* 对话框内容 */}
      <div className="relative w-80 bg-white rounded-2 p-6 shadow-lg">
        <div className="text-3.5 font-500 text-mx-secondary lh-5.5 mb-2">
          无法启动录制
        </div>

        <div className="text-3.5 text-mx-secondary mb-6 lh-5.5">
          {errorMessage}
        </div>

        <div className="flex justify-end gap-4">
          {isInSummaryPage ? (
            <>
              <button
                className="px-4 h-8 rounded-1.5 border-1 border-solid border-#ECEEF3 text-3.5 text-mx-secondary cursor-pointer bg-#fff"
                onClick={handleCancel}
              >
                取消
              </button>

              <button
                className="px-4 h-8 rounded-1.5 bg-#4981F2 text-3.5 text-white cursor-pointer border-none"
                onClick={handleStopRecording}
              >
                结束录制
              </button>
            </>
          ) : (
            <button
              className="px-4 h-8 rounded-1.5 bg-#4981F2 text-3.5 text-white cursor-pointer border-none"
              onClick={handleKnow}
            >
              知道了
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

StartRecordErrorDialog.displayName = "StartRecordErrorDialog";

export default StartRecordErrorDialog;

